<template>
    <auth>
        <b-form
            @submit.stop.prevent="onSubmit"
            @reset.stop.prevent="onReset"
            v-if="show"
            class="col-md-6 offset-md-3 text-center"
        >
            <b-form-group label="País:">
                <b-form-select
                    v-model="form.country"
                    :options="countries"
                    value-field="iso3"
                    text-field="nome"
                    required
                ></b-form-select>
            </b-form-group>

            <b-form-group label="Nome Completo:">
                <b-form-input
                    v-model="form.fullname"
                    type="text"
                    required
                    placeholder="Digite o nome completo"
                ></b-form-input>
            </b-form-group>

            <b-form-group label="Atuação">
                <b-form-checkbox-group v-model="form.jobs">
                    <b-form-checkbox value="Profissional"
                        >Profissional</b-form-checkbox
                    >
                    <b-form-checkbox value="Estudante"
                        >Estudante</b-form-checkbox
                    >
                    <b-form-checkbox value="Professor"
                        >Professor</b-form-checkbox
                    >
                    <b-form-checkbox value="Pesquisador"
                        >Pesquisador</b-form-checkbox
                    >
                </b-form-checkbox-group>
            </b-form-group>

            <b-form-group label="Instituição (Se houver):">
                <vue-bootstrap-typeahead 
                    v-model="form.institution"
                    :data="institutions"
                    placeholder="Digite o nome da instituição"
                />
            </b-form-group>

            <b-form-group label="E-mail:">
                <b-form-input
                    v-model="form.email"
                    type="email"
                    required
                    placeholder="Digite o email"
                ></b-form-input>
            </b-form-group>

            <b-form-group label="Senha:">
                <b-form-input
                    v-model="form.password"
                    type="password"
                    required
                    placeholder="Digite a Senha"
                ></b-form-input>
            </b-form-group>

            <b-form-group label="Confirmação de Senha:">
                <b-form-input
                    v-model="form.password_confirmation"
                    type="password"
                    required
                    placeholder="Confirme a Senha"
                ></b-form-input>
            </b-form-group>

            <div class="mb-3">
                <b-button type="submit" variant="primary">Cadastrar</b-button>
                &nbsp;&nbsp;&nbsp;
                <b-button type="reset" variant="danger">Limpar</b-button>
                &nbsp;&nbsp;&nbsp;
                <b-button type="button" variant="warning" @click="goback"
                    >Voltar</b-button
                >
            </div>
        </b-form>
    </auth>
</template>

<script>
import Auth from "./../layouts/Auth";
import countries from "./../assets/paises.json";
import Institution from "./../models/Institution";
import Swal from "sweetalert2";
import { sigunpAction } from "./../configs/services";
import Bus from "./../configs/bus";

export default {
    name: "Signup",
    components: {
        Auth
    },
    data() {
        return {
            form: {
                email: "",
                fullname: "",
                country: "Brasil",
                jobs: [],
                institution: "",
                password: ""
            },
            countries: countries.map(x => x.nome),
            institutions: [],
            show: true
        };
    },
    async created(){
        let items = await Institution.get();
        console.log(items);
        this.institutions = items.map(x => x.name);
    },
    methods: {
        goback() {
            window.history.back();
        },
        onSubmit(evt) {
            const vm = this;

            Bus.$emit("toggle", null);

            sigunpAction(this.form)
            .then(item => {
                Swal.fire("Sucesso!", "Você solicitou o cadastro com sucesso! Aguarde recebimento de e-mail para indicar que você já pode logar", "success")
                .then(() => {
                    vm.$router.push({name: "Login"})
                });
            })
            .catch(this.errorHandler)
            .then(function() {
                // always executed
                Bus.$emit("toggle", null);
            });
        },
        onReset(evt) {
            evt.preventDefault();
            // Reset our form values
            this.form = {
                email: "",
                fullname: "",
                country: "BRA",
                jobs: [],
                password: ""
            };
            // Trick to reset/clear native browser form validation state
            this.show = false;
            this.$nextTick(() => {
                this.show = true;
            });
        }
    }
};
/* eslint-disable no-console */
//import axios from 'axios';
//import VueElementLoading from 'vue-element-loading';
//import { apiServer } from './../configs/enviroment';
// import Cookies from 'js-cookie';

// export default {
//   name: 'signup',
//   components: {
//     Auth
//   },
//   data(){
//     return {
//       user: {
//         fullname: '',
//         email: '',
//         password: '',
//         password_confirmation: ''
//       }
//     }
//   },
//   methods: {
//     signup(){
//       Bus.$emit('toggle', null);

//     },
//     clear(){
//       this.user = {
//         fullname: '',
//         email: '',
//         password: '',
//       };
//     }
//   }
// }
</script>
